export default {
    hasFlag(Flags, flag, value = true) {
      return Flags.some((f) => f.flagId === flag && f.value === `${value}`);
    },
    flagValue(Flags, flag) {
      const flagObj = Flags.find((f) => f.flagId === flag);
      if (!flagObj) return null;
      return flagObj.value;
    }
  }